"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSchema = void 0;
var _culture = require("@ori/culture");
var _zod = require("zod");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../../hooks/useTranslations_simplified-registration-BrandPartner");
var _utils = require("../../../utils");
const useGetSchema = config => {
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const {
    culture
  } = (0, _culture.useCulture)();
  const culturePattern = culture?.calendarFormat?.patterns?.shortDatePattern;
  if (!config) {
    return _zod.z.object({});
  }
  const {
    birthDate,
    contactEmail,
    contactTelephone,
    firstName,
    gender,
    lastName,
    uniqueId,
    address
  } = config;
  let schema = _zod.z.object({});
  schema = _zod.z.object({
    contactEmail: (0, _utils.createFieldSchema)(formatMessage, contactEmail, 'string', undefined, 'email'),
    contactTelephone: (0, _utils.createFieldSchema)(formatMessage, contactTelephone, 'string', undefined, 'phone'),
    firstName: (0, _utils.createFieldSchema)(formatMessage, firstName, 'string'),
    lastName: (0, _utils.createFieldSchema)(formatMessage, lastName, 'string'),
    uniqueId: (0, _utils.createFieldSchema)(formatMessage, uniqueId, 'string', undefined, 'uniqueId'),
    birthDate: (0, _utils.createFieldSchema)(formatMessage, birthDate, 'date', culturePattern, 'birthDate'),
    gender: (0, _utils.createFieldSchema)(formatMessage, gender, 'genderEnum'),
    address: _zod.z.object({
      addressType: (0, _utils.createFieldSchema)(formatMessage, address?.addressType, 'string'),
      country: (0, _utils.createFieldSchema)(formatMessage, address?.country, 'string'),
      region: (0, _utils.createFieldSchema)(formatMessage, address?.region, 'string'),
      province: (0, _utils.createFieldSchema)(formatMessage, address?.province, 'string'),
      district: (0, _utils.createFieldSchema)(formatMessage, address?.district, 'string'),
      area: (0, _utils.createFieldSchema)(formatMessage, address?.area, 'string'),
      city: (0, _utils.createFieldSchema)(formatMessage, address?.city, 'string'),
      locality: (0, _utils.createFieldSchema)(formatMessage, address?.locality, 'string'),
      streetAddress: (0, _utils.createFieldSchema)(formatMessage, address?.streetAddress, 'string'),
      zipcode: (0, _utils.createFieldSchema)(formatMessage, address?.zipcode, 'string'),
      delivery: (0, _utils.createFieldSchema)(formatMessage, address?.delivery, 'string'),
      delivery2: (0, _utils.createFieldSchema)(formatMessage, address?.delivery2, 'string'),
      delivery3: (0, _utils.createFieldSchema)(formatMessage, address?.delivery3, 'string')
    }).nullish()
  });
  return schema;
};
exports.useGetSchema = useGetSchema;